import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { ConfigProvider } from "../../../config-provider.service";
import { Error404Component } from "../../components/error-404/error-404";

@Component({
  selector: 'error-404-page',
  providers: [],
  styleUrls: ['./error-404.scss'],
  standalone: true,
  imports: [
    Error404Component
  ],
  templateUrl: './error-404.html'
})
export class Error404PageComponent implements AfterViewInit {
    constructor(
        public breadcrumbProvider: BreadcrumbProvider,
        private configProvider: ConfigProvider,
        private changeDetectorRef: ChangeDetectorRef,
        private translateService: TranslateService
    ) {
    }

    public ngAfterViewInit() {
        this.breadcrumbProvider.setDefaultCrumbs([]);
        this.changeDetectorRef.detectChanges();
    }
}
